export default __webpack_public_path__ + "static/media/displayPlaceholder.c6463579.svg";